import { configure } from '@creditas/event-track';

const events = configure({
  application: 'header-mf-dashboard',
  bu: 'CR',
  environment: process.env.APP_ENV === 'production' ? 'production' : 'staging',
});

export { events };
